<template>
  <div>
    <v-data-table
      :items="statsDataFormatted"
      :headers="headers"
      :loading="loading"
      item-key="orgId"
      :items-per-page="-1"
      dense
    >
      <template v-slot:top>
        <div>
          <h1 align="center">Organization Stats</h1>
          <h3 align="center">{{ new Date().toLocaleString() }}</h3>
        </div>
        <div class="d-flex mb-5">
          <div class="d-flex tabs">
            <v-btn
              class="tab"
              :class="tab === 'all' ? 'tab--active' : ''"
              text
              @click="tab = 'all'"
            >
              All
            </v-btn>
            <v-btn
              class="tab"
              :class="tab === 'subscribed' ? 'tab--active' : ''"
              text
              @click="tab = 'subscribed'"
            >
              Subscribed
            </v-btn>
            <v-btn
              class="tab"
              :class="tab === 'unsubscribed' ? 'tab--active' : ''"
              text
              @click="tab = 'unsubscribed'"
            >
              Unsubscribed
            </v-btn>
          </div>
          <v-btn
            small
            plain
            text
            elevation="0"
            color="transparent"
            class="blue--text text-none hide-mobile export-btn"
            @click="exportCSV"
          >
            <v-icon>mdi-file-download</v-icon>
            Export CSV
          </v-btn>
        </div>
      </template>
      <template #item.linkToStripe="{ item }">
        <div v-if="item.linkToStripe === 'Not Subscribed'">
          {{ item.linkToStripe }}
        </div>
        <a v-else target="_blank" :href="item.linkToStripe"
          >Stripe Subscription</a
        >
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { getStatsData } from "@/helpers/api";

const headers = [
  {
    text: "Organization Name",
    value: "orgName",
    align: "start",
    divider: true,
    sortable: true
  },
  {
    text: "License Count",
    value: "licenseCount",
    align: "end",
    sortable: true,
    divider: true
  },
  {
    text: "Active Teams",
    value: "activeTeams",
    align: "end",
    sortable: true,
    divider: true
  },
  {
    text: "Unused Licenses",
    value: "unusedLicenses",
    align: "end",
    sortable: false,
    divider: true
  },
  {
    text: "Active Athletes",
    value: "activeAthletes",
    align: "end",
    sortable: true,
    divider: true
  },
  {
    text: "Active Fans",
    value: "activeFans",
    align: "end",
    sortable: true,
    divider: true
  },
  {
    text: "Inactive Teams",
    value: "inactiveTeams",
    align: "end",
    sortable: false,
    divider: true
  },
  {
    text: "Inactive Athletes",
    value: "inactiveAthletes",
    align: "end",
    sortable: false,
    divider: true
  },
  {
    text: "Inactive Fans",
    value: "inactiveFans",
    align: "end",
    sortable: false,
    divider: true
  },
  // {
  //   text: "Payments Processed This Year",
  //   value: "paymentsThisYear",
  //   align: "end",
  //   sortable: true,
  //   divider: true
  // },
  // {
  //   text: "Payments Processed Lifetime",
  //   value: "paymentsLifeTime",
  //   align: "end",
  //   sortable: true,
  //   divider: true
  // }
  {
    text: "Stripe Dashboard",
    value: "linkToStripe",
    align: "center",
    divider: true
  }
];

export default {
  name: "Stats.vue",
  data() {
    return {
      statsData: null,
      statsDataFormatted: [],
      headers,
      loading: true,
      tab: "all"
    };
  },
  watch: {
    tab: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.fetchStatsData();
      }
    },
    statsData: function(newStatsData, oldStatsData) {
      const statsDataFormatted = [];
      if (this.statsData) {
        this.statsData.statsItemList.map(i => {
          const x = {};
          x.orgName = i.orgName;
          x.activeFans = i.activeFans;
          x.activeAthletes = i.activeAthletes;
          x.activeTeams = i.activeTeams;
          x.licenseCount = i.licenseCount;
          x.unusedLicenses = x.licenseCount - x.activeTeams;
          x.unusedLicenses = x.unusedLicenses > 0 ? x.unusedLicenses : 0;
          x.inactiveFans = i.fans - i.activeFans;
          x.inactiveAthletes = i.athletes - i.activeAthletes;
          x.inactiveTeams = i.teams - i.activeTeams;
          if (i.subscriptionId != null) {
            x.linkToStripe = `https://dashboard.stripe.com/subscriptions/${i.subscriptionId}`;
          } else {
            x.linkToStripe = "Not Subscribed";
          }
          if (i.paymentsThisYear != 0) {
            const price = i.paymentsThisYear.toString();
            x.paymentsThisYear =
              "$" +
              price.slice(0, price.length - 2) +
              "." +
              price.slice(price.length - 2);
          } else {
            x.paymentsThisYear = i.paymentsThisYear;
          }
          if (i.paymentsLifeTime != 0) {
            const price = i.paymentsLifeTime.toString();
            x.paymentsLifeTime =
              "$" +
              price.slice(0, price.length - 2) +
              "." +
              price.slice(price.length - 2);
          } else {
            x.paymentsLifeTime = i.paymentsLifeTime;
          }
          statsDataFormatted.push(x);
        });
        this.statsDataFormatted = statsDataFormatted;
      } else {
        this.statsDataFormatted = [];
      }
    }
  },
  methods: {
    async fetchStatsData() {
      this.loading = true;
      this.statsData = await getStatsData(this.tab);
      this.loading = false;
    },
    async exportCSV() {
      const rows = [];
      const headerRow = [];
      this.headers.forEach(i => headerRow.push(i.text));
      rows.push(headerRow);
      this.statsDataFormatted.forEach(i => {
        const row = [];
        row.push(i.orgName);
        row.push(i.licenseCount);
        row.push(i.activeTeams);
        row.push(i.unusedLicenses);
        row.push(i.activeAthletes);
        row.push(i.activeFans);
        row.push(i.inactiveTeams);
        row.push(i.inactiveAthletes);
        row.push(i.inactiveFans);
        row.push(i.linkToStripe);
        rows.push(row);
      });
      const csvContent =
        "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");
      const encodeUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodeUri);
      link.setAttribute("download", "TeamBot_Stats.csv");
      document.body.appendChild(link);
      link.click();
    }
  },
  mounted() {
    this.fetchStatsData();
  }
};
</script>

<style scoped>
.tabs {
  margin: 1vh auto 0 auto;
}
.export-btn {
  position: absolute;
  right: 1vw;
}
.tab {
  margin: 0 1vw 0 1vw;
  text-transform: none !important;
  font-size: 0.8rem;
}
.tab--active {
  color: #1f97ff;
}
.expand-btn {
  height: 1vh;
  width: 1vw;
}
</style>
